const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

/** "1665-05-14" reads as a stored value; "14 May 1665" reads as a day someone lived through. */
export function formatHistoricalDate(value: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/u.exec(value);
  if (match === null) return value;
  const [, year, month, day] = match;
  const name = MONTHS[Number(month) - 1];
  if (name === undefined) return value;
  return `${Number(day)} ${name} ${year}`;
}

export function yearsSince(year: number, now: Date): number {
  return now.getFullYear() - year;
}
